import { selectedProducts } from 'qs-data-manager/Selected';
import { getActiveProductId, resetActiveProductId } from 'qs-data-manager/Products';

export const resetForLabelScreen = () => {
  if (getActiveProductId() || selectedProducts.isAnySelected()) {
    selectedProducts.removeAll();
    resetActiveProductId();
  }
};
